module.exports = __webpack_public_path__ + "media/images/products/cards/dividendos-9242cb519ffcc838bf5934adf9160ae1.png";